function readEnv(name: string): string | undefined {
    const v = process.env[name];
    return typeof v === "string" && v.trim() ? v.trim() : undefined;
}

function required(...names: string[]): string {
    for (const n of names) {
        const v = readEnv(n);
        if (v) return v;
    }
    throw new Error(
        `Missing env var. Set one of: ${names.join(", ")} in your .env file`
    );
}

export const config = {
    smartRoutesAuthorizationBaseUrl: required(
        "REACT_APP_SMART_ROUTES_AUTHORIZATION_BASE_URL"
    ),
    smartRoutesGuideBaseUrl: required(
        "REACT_APP_SMART_ROUTES_GUIDE_BASE_URL"
    ),
    smartRoutesMonitoringBaseUrl: required(
        "REACT_APP_SMART_ROUTES_MONITORING_BASE_URL"
    ),
    smartRoutesPlanRouteBaseUrl: required(
        "REACT_APP_SMART_ROUTES_PLAN_ROUTE_BASE_URL"
    ),
    yandexMapsApiKey: required(
        "REACT_APP_YANDEX_MAPS_API_KEY"
    ),
} as const;
